module.exports = __webpack_public_path__ + "img/partner.a75997bc.png";